/* eslint-disable react-hooks/exhaustive-deps */
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import ReactGA from "react-ga";
import { useDispatch } from "react-redux";
import { updateAWS } from "services/s3";
import "./App.css";
import { getLocalUser } from "./main/shared/helpers";
import { authRoles } from "./navigation/route-config";
import AppRouter from "./navigation/router";
import { profileRequest } from "./services/auth-service";
import { LOG_IN } from "./store/actions";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const TRACKING_ID = process.env.REACT_APP_GOOGLE_ANALYTICS; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch();
  useEffect(() => {
    const initializeApp = async () => {
      let localUser = null;
      let localUserType = null;

      try {
        localUser = getLocalUser();
        localUserType = atob(localStorage.getItem("user_type"));
      } catch (e) {
        console.log("get local user failed", e);
      }
      if (
        localUser !== null &&
        localUserType !== authRoles.buSubAdmin &&
        localUserType !== authRoles.buInspector
      ) {
        dispatch({
          type: LOG_IN,
          payload: localUser,
        });

        try {
          await updateAWS();
        } catch (error) {
          console.log("AWS update failed:", error);
        }
        setIsLoading(false);
      } else if (localStorage.getItem("access_token")) {
        profileRequest()
          .then(async (res) => {
            try {
              await updateAWS();
            } catch (error) {
              console.log("AWS update failed:", error);
            }
            dispatch({
              type: LOG_IN,
              payload: res.data,
            });
          })
          .catch((err) => {
            console.log("Profile request failed:", err.response);
            // If profile request fails, clear invalid token
            if (err.response?.status === 401) {
              localStorage.removeItem("access_token");
            }
          })
          .finally(() => {
            setIsLoading(false);
          });
      } else {
        setIsLoading(false);
      }
    };

    initializeApp();
  }, []);

  return isLoading ? (
    <Spinner animation="border" variant="success" className="app-spinner" />
  ) : (
    <AppRouter />
  );
}

export default App;

let isReloadingForSWUpdate = false;

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (!registration?.waiting) {
      console.log(
        "Service worker update detected but no waiting worker found."
      );
      return;
    }

    window.alert(
      "🚀 A new version of Scout is available.\n\nWe’ll reload the app now to keep everything up to date."
    );

    try {
      console.log("Auto-applying service worker update…");
      registration.waiting.postMessage({ type: "SKIP_WAITING" });

      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (isReloadingForSWUpdate) {
          return;
        }
        isReloadingForSWUpdate = true;
        console.log("Service worker controller changed, reloading…");
        window.location.reload();
      });

      setTimeout(() => {
        if (!isReloadingForSWUpdate) {
          console.log("Fallback reload triggered after SW update.");
          window.location.reload();
        }
      }, 3000);
    } catch (error) {
      console.error("Error while applying service worker update:", error);
      window.location.reload();
    }
  },
  onSuccess: (registration) => {
    console.log("✅ Service worker registered successfully:", {
      scope: registration?.scope,
      updateViaCache: registration?.updateViaCache,
      active: !!registration?.active,
    });
  },
  onError: (error) => {
    console.error("❌ Service worker registration failed:", {
      error: error?.message || error,
      isSecureContext: window.isSecureContext,
      protocol: window.location.protocol,
      hostname: window.location.hostname,
    });
  },
});
